/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC4yNjY2NyAxNVYxMS4zNzA0SDBWMUgxNlYxMS4zNzA0SDkuMjQ4TDQuMjY2NjcgMTVaTTEuMDY2NjcgMTAuMzMzM0g1LjMzMzMzVjEyLjkyNTlMOC44ODUzMyAxMC4zMzMzSDE0LjkzMzNWMi4wMzcwNEgxLjA2NjY3VjEwLjMzMzNaIiBmaWxsPSJpbmhlcml0Ii8+PC9zdmc+";